import React, { Component } from 'react';
import PSPDFKit from '../pspdfkit';
import {
  getForms,
  sendFormData,
  getDocumentArrayBuffer,
  checkTosCookie,
  setTosCookie
} from '../../api/choiceforms';
import TosModal from './termsofusemodal';

/**
 * need button to save changes/move to the next step
 *   pass in functino so we can call when done
 *
 * url client/order
 * call out to client/fillableforms/order to get list of forms we need to fill out
 * get the first form and display
 * on submit capture data as formid/whatever
 * go to next
 * when done submit to client/fillableform/*orderid
 * redirect to the page that is returned
 */

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

export class FormViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completedForms: {},
      showModal: false
    };
    this.acceptTerms = this.acceptTerms.bind(this);
  }

  async componentDidMount() {
    const orderid = this.props.match.params.superid;
    const client = this.props.match.params.client;
    //look for optional current student param
    let currentStudent = '';
    if (this.props.match.params.currentStudent) {
      currentStudent = this.props.match.params.currentStudent;
    }
    var host = `https://${client}`;
    if (process.env.NODE_ENV === 'development') {
      host = `http://${client}`;
    }
    checkTosCookie(client).then(async response => {
      this.setState({
        ...this.state,
        showModal: response === 'invalid'
      });
    });
    try {
      const forms = await getForms(client, orderid);
      const currentForm = 0;
      const pdfUrl = `${host}/questions/form/${
        forms[currentForm]
      }?orderid=${orderid}&currentStudent=${currentStudent}`;
      const pdfContent = await getDocumentArrayBuffer(pdfUrl);
      this.setState((state, props) => {
        return {
          client,
          currentForm,
          forms,
          finishedLoading: true,
          orderid,
          pdfContent
        };
      });
    } catch (error) {
      console.log('caught error');
      console.log(error);
      this.setState((state, props) => {
        return {
          error: true,
          errorMessage: error
        };
      });
    }
  }

  async acceptTerms() {
    setTosCookie(this.state.client);
  }

  async formCompleted(formid, xfdf) {
    console.log('signature');
    // add formd data
    const completedForms = this.state.completedForms;
    completedForms[formid] = {};
    completedForms[formid] = xfdf;
    console.log('passing', completedForms[formid]);
    const currentForm = this.state.currentForm + 1;
    let finishedLoading = this.state.finishedLoading;

    if (currentForm >= this.state.forms.length) {
      //finished all the forms... cubmit to the order
      finishedLoading = false;
      const result = await sendFormData(
        this.state.client,
        this.state.orderid,
        this.state.completedForms
      );
      //on success go to returned url
      window.location = result.returnUrl;
      return;
    }
    var host = `https://${this.state.client}`;
    if (process.env.NODE_ENV === 'development') {
      host = `http://${this.state.client}`;
    }
    let currentStudent = '';
    if (this.props.match.params.currentStudent) {
      currentStudent = this.props.match.params.currentStudent;
    }
    const pdfUrl = `${host}/questions/form/${
      this.state.forms[currentForm]
    }?orderid=${this.state.orderid}&currentStudent=${currentStudent}`;
    const pdfContent = await getDocumentArrayBuffer(pdfUrl);

    this.setState((state, props) => {
      return {
        completedForms: { ...completedForms },
        currentForm,
        finishedLoading,
        pdfContent
      };
    });
  }

  render() {
    let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;

    if (this.state.finishedLoading) {
      var host = `https://${this.state.client}`;
      if (process.env.NODE_ENV === 'development') {
        host = `http://${this.state.client}`;
      }
      const title = `Form ${this.state.currentForm + 1} of ${
        this.state.forms.length
      }`;
      const currentFormId = this.state.forms[this.state.currentForm];
      let imageUrl = host + '/casfiles/choice_fillableform_hero.png';
      if (currentFormId && currentFormId.indexOf('_signeddoc') > 0) {
        imageUrl = host + '/casfiles/signed_document_hero.png';
      }
      return (
        <div
          className="App"
          style={{
            backgroundColor: '#fff',
            'max-width': '1170px',
            'margin-right': 'auto',
            'margin-left': 'auto'
          }}
        >
          <img alt="hero" className={'d-none d-md-block'} src={imageUrl} />
          {this.state.error && <div>{this.state.errorMessage}</div>}
          {this.state.finishedLoading && (
            <PSPDFKit
              documentId={this.state.currentForm}
              pdfUrl={this.state.pdfContent}
              licenseKey={licenseKey}
              baseUrl={baseUrl}
              completedForm={xfdf => {
                this.formCompleted(currentFormId, xfdf);
              }}
              hideToolbar={true}
              title={title}
              maxWidth="1170px"
            />
          )}

          <TosModal
            modal={this.state.showModal}
            onConfirm={this.acceptTerms}
            client={this.state.client}
          />
        </div>
      );
    }
    return null;
  }
}

export default FormViewer;
